<template>
  <form class="form__sign-in" @submit.prevent="register">
    <div class="logo">
      <img src="@/assets/image/logo-black.svg">
      <h1>{{ $t('personal-communications-system') }}</h1>
      <p>{{ $t('entry') }}</p>
    </div>
    <div class="main-form">
      <div class="form-group">
        <label>Email</label>
        <input type="text" v-model.trim="email" class="form-control">
        <span class="error" v-if="errors.email">{{ errors.email[0] }}</span>
      </div>
      <div class="form-group">
        <label>{{ $t('login') }}</label>
        <input type="text" v-model.trim="username" class="form-control">
        <span class="error" v-if="errors.username">{{ errors.username[0] }}</span>
      </div>
      <div class="form-group">
        <label>{{ $t('password') }}</label>
        <input type="password" v-model="password" class="form-control">
        <span class="error" v-if="errors.password">{{ errors.password[0] }}</span>
      </div>
      <div class="form-footer">
        <router-link to="/login">Вход</router-link>
      </div>
    </div>
    <button class="btn" type="submit">Регистрация</button>
    <p class="sign__in-help">{{ $t('sign-up-help') }}<b> support@expansium.ru</b></p>
  </form>
</template>

<script>
export default {
  data: function(){
    return{
      email: null,
      username: null,
      password: null,
      errors: []
    }
  },
  methods: {
    register: function() {
      let email = this.email;
      let username = this.username;
      let password = this.password;
      this.$store.dispatch("register", { email, username, password })
          .then(response => {
            if(response.data.status){
              this.$router.push({ name: 'login' });
              this.$toast.success('Вы успешно зарегистрировались!');
            }
          }).catch(err => {
        this.errors = err;
      });
    }
  }
};
</script>

<style scoped>
.form-footer{
  display: flex;
  justify-content: flex-end;
}
.form-footer a{
  display: block;
  text-align: left;
  margin-top: -15px;
  text-decoration: underline;
  font-size: 14px;
  font-weight: bold;
  color: #252229;
}
.btn{
  background: #FFAE00;
  border-radius: 50px !important;
  font-weight: bold !important;
  font-size: 18px !important;
  line-height: 136.4%;
  color: #000000 !important;
  width: 370px;
}
.form__sign-in{
  position: absolute;
  top: 20%;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  max-width: 700px;
}
.form__sign-in .logo h1{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #252229;
  margin-top: 65px;
}
.form__sign-in .logo p{
  margin-top: 50px !important;
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #252229;
}
.form__sign-in .main-form{
  max-width: 360px;
  margin: 0 auto;
}
.form__sign-in .form-group{
  margin-bottom: 25px;
}
.form__sign-in .form-group label{
  font-size: 14px;
  line-height: 145%;
  color: #252229;
  display: block;
  text-align: left;
  margin-bottom: 5px;
}
.form__sign-in .form-group input{
  width: 360px;
  height: 50px;
}
.form__register a{
  color: #252229;
}
button[type=submit]{
  margin-top: 25px;
}
.sign__in-help{
  color: #252229;
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  text-align: center;
  margin-top: 70px !important;
}
</style>